import { Branch } from "./Branch";
import { LinkedCompany } from "@/features/modules/company/objects/LinkedCompany";
import { LinkedFirestoreOfflineDocument } from "@/core/modules/firestore/objects/LinkedFirestoreOfflineDocument";

import { ObjectField, StringField, BooleanField } from "@/core/fields";

export class LinkedBranch extends LinkedFirestoreOfflineDocument {
  public company: LinkedCompany | undefined = undefined;
  public name: string | undefined = undefined;
  public legalBranch = false;

  public constructor(firestoreData?: Record<string, unknown>) {
    super();
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);
  }

  public static createFromBranch(branch: Branch): LinkedBranch {
    const linkedBranch: LinkedBranch = new LinkedBranch();
    linkedBranch.id = branch.id;
    linkedBranch.company = branch.company;
    linkedBranch.name = branch.name;
    linkedBranch.legalBranch = branch.legalBranch;

    return linkedBranch;
  }

  public fromFirestore(data: Record<string, unknown>): LinkedBranch {
    super.fromFirestore(data);

    this.company = ObjectField.fromFirestore<LinkedCompany>(data.company, (value) => new LinkedCompany(value));
    this.name = StringField.fromFirestore(data.name);
    this.legalBranch = BooleanField.fromFirestore(data.legalBranch);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.company = ObjectField.toFirestore<LinkedCompany>(this.company, (value) => value.toFirestore());
    firestoreData.name = StringField.toFirestore(this.name);
    firestoreData.legalBranch = BooleanField.toFirestore(this.legalBranch);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): LinkedBranch {
    super.fromOfflineCache(data);

    this.company = ObjectField.fromOfflineCache<LinkedCompany>(data.company, (value) => new LinkedCompany(value));
    this.name = StringField.fromOfflineCache(data.name);
    this.legalBranch = BooleanField.fromOfflineCache(data.legalBranch);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.company = ObjectField.toOfflineCache<LinkedCompany>(this.company, (value) => value.toOfflineCache());
    firestoreData.name = StringField.toOfflineCache(this.name);
    firestoreData.legalBranch = BooleanField.toOfflineCache(this.legalBranch);

    return firestoreData;
  }
}
